var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center justify-center h-full"},[_c('vs-chip',{staticStyle:{"height":"30px"},attrs:{"color":_vm.params.value ? 'success' : 'danger'}},[_vm._v("\n    "+_vm._s(_vm.params.value ? 'نشط' : 'غير نشط')+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }